import { css, styled } from "../../../../../../../styles";

export const Secondarybutton = styled("button", {
  width: "100%",
  height: "$13",
  padding: "0 $13",
  maxWidth: "300px",
  margin: "0 auto 18px auto",

  border: "none",
  borderRadius: "$8",

  "&:focus-visible": {
    outline: "none",
  },

  display: "flex",
  alignItems: "center",
  justifyContent: "center",

  color: "var(--colors-black)",
  backgroundColor: "var(--colors-gray-50)",

  fontWeight: 600,
  lineHeight: "22px",
  fontSize: "$text-lg",
  fontFamily: "$openSans",

  cursor: "pointer",

  variants: {
    disabled: {
      true: {
        opacity: 0.38,
        cursor: "initial",
      },
    },
  },
});

export const buttonCss = css({
  marginBottom: "12px",
  width: "100%",
  display: "flex",
  justifyContent: "center",

  button: {
    maxWidth: "300px",
    width: "100%",
    height: "40px",

    display: "flex",
    flexDirection: "row",
    justifyContent: "center",

    fontSize: "16px",
    fontWeight: "600",
    lineHeight: "22px",
    fontFamily: "$openSans",
  },
});

export const uploadCss = css({
  width: "100%",
  display: "flex",
  justifyContent: "center",

  ".ant-upload": {
    width: "100%",
    display: "flex",
    justifyContent: "center",
  },
});
